/* global axios */
import ApiClient from '../ApiClient';

class CaptainMcpConnectors extends ApiClient {
  constructor() {
    super('captain/mcp_connectors', { accountScoped: true });
  }

  get({ page = 1, searchKey } = {}) {
    return axios.get(this.url, {
      params: { page, searchKey },
    });
  }

  show(id) {
    return axios.get(`${this.url}/${id}`);
  }

  create(data = {}) {
    return axios.post(this.url, {
      mcp_connector: data,
    });
  }

  update(id, data = {}) {
    return axios.put(`${this.url}/${id}`, {
      mcp_connector: data,
    });
  }

  delete(id) {
    return axios.delete(`${this.url}/${id}`);
  }

  test(data = {}) {
    return axios.post(`${this.url}/test`, {
      mcp_connector: data,
    });
  }

  sync(id) {
    return axios.post(`${this.url}/${id}/sync`);
  }
}

export default new CaptainMcpConnectors();
